export const getRateLimitIndexByTimeout = (retryAfterMs: number): number => {
  // This function determines what content to show on the dialog when the user resends an SMS.
  // This is based on the retryAfterMs value returned from the API.
  // This is not ideal, since it is coupled with how the backend behaves, but it is also
  // okay in a sense that we have a single source of truth for the retry logic.
  // Besides, we're showing a generic message for each retry attempt anyway.
  // Managing a "retry count" in the frontend is worse - aside from making the implementation
  // unnecessary complicated, there will be instances where the user thinks they can retry,
  // but the backend will not allow it, or vice versa, and it leads to a confusing user experience.
  // I think one of the best solutions would be to store these timeouts in LaunchDarkly rather than
  // hardcoding them here and in the backend.

  if (retryAfterMs >= 0 && retryAfterMs < 60_000) {
    return 0;
  }

  if (retryAfterMs < 120_000) {
    return 1;
  }

  if (retryAfterMs < 180_000) {
    return 2;
  }

  if (retryAfterMs < 240_000) {
    return 3;
  }

  if (retryAfterMs < 3_600_000) {
    return 4;
  }

  return 5;
};
